import * as actionTypes from "../../constants/actionTypes";
import * as handlers from "../../constants/handlers";
import * as messageHelper from "../../helpers/messageHelper";
import * as responseHelper from "../../helpers/responseHelper";

export const processWebsocketResponse = (tabId, method, response, state) => {
    switch (method) {
        case handlers.FILTERING_GET_DEFAULT_PRODUCT_LIST:
            if (!responseHelper.isGroupListFormatValid(response, true)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.FILTERING_SAVE_DEFAULT_PRODUCT_LIST,
                    payload: {
                        tabId: tabId,
                        productList: response.data
                    }
                }
            ];
        case handlers.FILTERING_GET_DEFAULT_FANDECK_LIST:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            let filteringFandeckListRequest = state.server.requests.find((request) => request.id === response.sequence);

            if (filteringFandeckListRequest !== undefined && filteringFandeckListRequest.next !== null) {
                return [
                    {
                        type: actionTypes.FILTERING_SAVE_DEFAULT_FANDECK_LIST,
                        payload: {
                            tabId: tabId,
                            fandeckList: response.data
                        }
                    },
                    filteringFandeckListRequest.next
                ];
            }

            return [
                {
                    type: actionTypes.FILTERING_SAVE_DEFAULT_FANDECK_LIST,
                    payload: {
                        tabId: tabId,
                        fandeckList: response.data
                    }
                }
            ];
        case handlers.FILTERING_GET_LOCAL_FANDECK_LIST:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.FILTERING_SAVE_LOCAL_FANDECK_LIST,
                    payload: {
                        tabId: tabId,
                        fandeckList: response.data
                    }
                }
            ];
        case handlers.FILTERING_GET_DEFAULT_FORMULA_LIST:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            let filteringFormulaListRequest = state.server.requests.find((request) => request.id === response.sequence);

            if (filteringFormulaListRequest !== undefined && filteringFormulaListRequest.next !== null) {
                return [
                    {
                        type: actionTypes.FILTERING_SAVE_DEFAULT_FORMULA_LIST,
                        payload: {
                            tabId: tabId,
                            colorList: response.data
                        }
                    },
                    filteringFormulaListRequest.next
                ];
            }

            return [
                {
                    type: actionTypes.FILTERING_SAVE_DEFAULT_FORMULA_LIST,
                    payload: {
                        tabId: tabId,
                        colorList: response.data
                    }
                }
            ];
        case handlers.FILTERING_GET_LOCAL_FORMULA_LIST:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.FILTERING_SAVE_LOCAL_FORMULA_LIST,
                    payload: {
                        tabId: tabId,
                        colorList: response.data
                    }
                }
            ];
        case handlers.FILTERING_GET_DEFAULT_FORMULA_CODE_LIST:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            let filteringFormulaCodeListRequest = state.server.requests.find(
                (request) => request.id === response.sequence
            );

            if (filteringFormulaCodeListRequest !== undefined && filteringFormulaCodeListRequest.next !== null) {
                return [
                    {
                        type: actionTypes.FILTERING_SAVE_DEFAULT_FORMULA_CODE_LIST,
                        payload: {
                            tabId: tabId,
                            colorList: response.data
                        }
                    },
                    filteringFormulaCodeListRequest.next
                ];
            }

            return [
                {
                    type: actionTypes.FILTERING_SAVE_DEFAULT_FORMULA_CODE_LIST,
                    payload: {
                        tabId: tabId,
                        colorList: response.data
                    }
                }
            ];
        case handlers.FILTERING_GET_LOCAL_FORMULA_CODE_LIST:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.FILTERING_SAVE_LOCAL_FORMULA_CODE_LIST,
                    payload: {
                        tabId: tabId,
                        colorList: response.data
                    }
                }
            ];
        case handlers.FILTERING_GET_DEFAULT_BASE_LIST:
            if (!responseHelper.isGetBasesByProductFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.FILTERING_SAVE_DEFAULT_BASE_LIST,
                    payload: {
                        tabId: tabId,
                        baseList: response.data.baseList
                    }
                }
            ];
        case handlers.FILTERING_GET_DEFAULT_PACKAGE_LIST:
            if (!responseHelper.isGetPackagesByParamsFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.FILTERING_SAVE_DEFAULT_PACKAGE_LIST,
                    payload: {
                        tabId: tabId,
                        packageList: response.data.packageList
                    }
                }
            ];
        case handlers.FILTERING_GET_DEFAULT_CUSTOMER_LIST:
            if (!responseHelper.isGetCustomersByParamsFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.FILTERING_SAVE_DEFAULT_CUSTOMER_LIST,
                    payload: {
                        tabId: tabId,
                        customerList: response.data.customerList
                    }
                }
            ];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
